import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import ArcadeOpsLogo from "@/components/ArcadeOpsLogo";
import { TRIAL_DAYS } from "@/lib/pricing";

const LINKS = [
  ["How it works", "/#how-it-works", "nav-how-it-works"],
  ["Pricing", "/pricing", "nav-pricing"],
  ["States", "/states", "nav-states"],
  ["For Venues", "/fortune", "nav-for-venues"],
  ["Operators", "/#operators", "nav-operators", "hidden lg:inline"], // desktop-only so the md bar keeps its width
  ["Campaigns", "/#campaigns", "nav-campaigns"],
  ["Blog", "/blog", "nav-blog"],
];

// Public top navigation shared by /, /saas, /pricing and /fortune.
export default function PublicNav() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const active = (href) => href === pathname;
  return (
    <nav className="border-b border-border/60 backdrop-blur-md bg-background/80 sticky top-0 z-40" data-testid="public-nav">
      <div className="max-w-7xl mx-auto px-4 h-16 flex items-center justify-between gap-3">
        <a href="/" data-testid="public-nav-logo" className="flex items-center shrink-0"><ArcadeOpsLogo size={34} showWordmark /></a>
        <div className="hidden md:flex items-center gap-6">
          {LINKS.map(([label, href, tid, extra = ""]) => (
            <a key={href} href={href} data-testid={tid} className={`font-mono text-[11px] uppercase tracking-widest transition-colors ${extra} ${active(href) ? "text-neon-yellow" : "text-white/70 hover:text-white"}`}>{label}</a>
          ))}
        </div>
        <div className="hidden md:flex items-center gap-2">
          <Link to="/login" data-testid="nav-login" className="inline-flex items-center h-9 px-4 border border-border text-white/85 hover:border-white hover:text-white transition-colors font-mono text-[11px] uppercase tracking-widest">Log in</Link>
          <Link to="/login?mode=register&plan=trial" data-testid="nav-start-trial" className="inline-flex items-center h-9 px-4 bg-neon-yellow text-black hover:bg-white transition-colors font-heading font-bold text-xs uppercase tracking-wide">Start {TRIAL_DAYS}-day trial</Link>
        </div>
        <button type="button" data-testid="nav-menu-toggle" onClick={() => setOpen((o) => !o)} aria-label="Menu" className="md:hidden h-9 w-9 inline-flex items-center justify-center border border-border text-white/80">
          {open ? <X className="w-4 h-4" /> : <Menu className="w-4 h-4" />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-border/60 bg-background px-4 py-3 space-y-1" data-testid="nav-mobile-menu">
          {LINKS.map(([label, href, tid]) => (
            <a key={href} href={href} data-testid={`${tid}-mobile`} onClick={() => setOpen(false)} className="block py-2 font-mono text-xs uppercase tracking-widest text-white/80 hover:text-white">{label}</a>
          ))}
          <div className="pt-2 flex gap-2">
            <Link to="/login" data-testid="nav-login-mobile" className="flex-1 inline-flex items-center justify-center h-10 border border-border font-mono text-[11px] uppercase tracking-widest">Log in</Link>
            <Link to="/login?mode=register&plan=trial" data-testid="nav-start-trial-mobile" className="flex-1 inline-flex items-center justify-center h-10 bg-neon-yellow text-black font-heading font-bold text-xs uppercase tracking-wide">Start trial</Link>
          </div>
        </div>
      )}
    </nav>
  );
}
